/** biome-ignore-all lint/style/useNamingConvention: Component name */
import { type ComponentType, Suspense } from 'react';

import type { CircularProgressProps } from '@mui/material';

import { Spinner } from '@ll-platform/frontend/components/Spinner/Spinner';
import SuspenseLoader from '@ll-platform/frontend/components/SuspenseLoader';

export const withLoader =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

export const withSpinner =
  <P extends object>(
    Component: ComponentType<P>,
    spinnerProps?: CircularProgressProps,
  ) =>
  (props: P) => (
    <Suspense fallback={<Spinner {...spinnerProps} />}>
      <Component {...props} />
    </Suspense>
  );
